/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { BUILD_SEMVER } from '../../../base/common/$__metadata.js';
import { memoize } from '../../../base/common/decorators.js';
import { IProductConfiguration } from '../../../base/common/product.js';
import { createDecorator } from '../../instantiation/common/registry.js';

export const IProductService = createDecorator<IProductService>('productService');

export interface IProductService extends Readonly<IProductConfiguration> {

	readonly _serviceBrand: undefined;

	get<K extends keyof IProductConfiguration>(key: K): IProductConfiguration[K] | undefined;

}

export const productSchemaId = 'needle://schemas/needle-product';



// #region Product Implementation

export class ProductService implements IProductService {
	readonly _serviceBrand: undefined;

	constructor(conf: IProductConfiguration) {
		this.configuration = {
			...conf
		}
	}

	private readonly configuration: IProductConfiguration;

	get<K extends keyof IProductConfiguration>(key: K): IProductConfiguration[K] | undefined {
		return this.configuration[key];
	}

	get version(): string {
		return this.configuration.version || BUILD_SEMVER || '0.0.0-dev';
	}
	get environment(): "dev" | "production" | ({} & string) {
		return this.configuration.environment;
	}
	get date(): string | undefined {
		return this.configuration.date;
	}
	get nameLong(): string {
		return this.configuration.nameLong;
	}
	get nameShort(): string {
		return this.configuration.nameShort;
	}
	get commit(): string | undefined {
		return this.configuration.commit;
	}
	get quality(): string | undefined {
		return this.configuration.quality;
	}

}